import updateChatHistory from '../../helpers/updateChatHistory';

export default (state, action, config) => {
  const currentResource =
    state[config.propName][action.payload.resourceId] || {};
  const currentResourceChats = currentResource.chats || {};
  const currentChat = currentResourceChats[action.payload.chatId] || {};
  const currentHistory = currentChat.history || [];

  return {
    ...state,
    [config.propName]: {
      ...state[config.propName],
      [action.payload.resourceId]: {
        ...currentResource,
        chats: {
          ...currentResourceChats,
          [action.payload.chatId]: {
            ...currentChat,
            ...updateChatHistory(
              currentChat.chatInfo || {},
              {
                history: action.payload.history,
                pagerFromApi: action.payload.pagerFromApi,
                total: action.payload.total,
              },
              currentHistory,
              currentChat.nextPager,
              currentChat.lastReadMessageId,
              config.messageModelCreator
            ),
          },
        },
      },
    },
  };
};
